/**
 * Feature Flags Hook
 * Uses Firebase Remote Config to control feature visibility
 */

import { useState, useEffect } from 'react'
import { getValue, fetchAndActivate } from 'firebase/remote-config'
import { remoteConfig } from '@/config/firebase'

export interface FeatureFlags {
  enableSecretSanta: boolean
}

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState<FeatureFlags>({
    enableSecretSanta: false,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadFlags = async () => {
      try {
        // Fetch and activate latest values
        await fetchAndActivate(remoteConfig)

        // Get flag values
        const enableSecretSanta = getValue(remoteConfig, 'enable_secret_santa').asBoolean()

        setFlags({
          enableSecretSanta,
        })
      } catch (error) {
        console.error('Error loading feature flags:', error)
        // Use default values on error
        setFlags({
          enableSecretSanta: false,
        })
      } finally {
        setLoading(false)
      }
    }

    loadFlags()
  }, [])

  return { flags, loading }
}
